
import React from 'react';
import { Button } from "@/components/ui/button";
import { Download, Mail, Calendar } from 'lucide-react';
import { toast } from "sonner";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

export const ContactHeader = () => {
  // Updated URLs for the resume versions
  const interactiveResumeUrl = "https://claude.ai/public/artifacts/e7329cf5-7857-475f-afda-9efc095a604c";
  const atsResumeUrl = "https://docs.google.com/document/d/1W29a_P_ANL3mio4HBA6JowbaqX3iV4O5_sWWD7y0pgA/edit?usp=sharing";
  
  // Function to track resume downloads
  const trackResumeInteraction = (type: string, version: string) => {
    console.log(`Resume ${type}: ${version} resume`);
    
    // Show toast notification
    toast(`${version} resume ${type === 'download' ? 'downloaded' : 'viewed'}`, {
      description: `You've successfully ${type === 'download' ? 'downloaded' : 'viewed'} the ${version} resume.`,
    });
  };
  
  // Function to handle resume viewing or downloading
  const handleResumeAction = (url: string, isDownload: boolean, version: string) => {
    // Open in new tab to ensure it works when shared externally
    window.open(url, '_blank', 'noopener,noreferrer');
    trackResumeInteraction(isDownload ? 'download' : 'view', version);
  };
  
  return (
    <div className="mb-10 relative">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <Avatar className="w-24 h-24 md:w-28 md:h-28 border-4 border-white shadow-lg">
          <AvatarImage src="/lovable-uploads/202d7088-df35-45e9-9b34-5cae17101b80.png" alt="Payton Hunter, Psychology Graduate" />
          <AvatarFallback>PH</AvatarFallback>
        </Avatar>
      </div>
      
      <div className="pt-14 md:pt-16">
        <h2 className="text-sage-800 text-xl md:text-2xl mb-2">Download & Connect</h2>
        <div className="w-20 md:w-24 h-1 bg-sage-300 mx-auto"></div>
        <p className="mt-4 text-sage-700 text-sm md:text-base max-w-md md:max-w-2xl mx-auto px-4 md:px-0">
          Let's explore how my skills and experience can contribute to your team
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-8 md:mb-12 mt-6 md:mt-8 px-4">
          <Button 
            className="bg-sage-600 hover:bg-sage-700 text-white flex items-center gap-2 transition-all duration-300 transform hover:scale-105 text-sm md:text-base py-2 h-auto"
            onClick={() => handleResumeAction(atsResumeUrl, true, 'ATS-friendly')}
          >
            <Download className="h-4 w-4" />
            <span>Download My Resume</span>
          </Button>
          
          <Button 
            variant="outline" 
            className="border-sage-600 text-sage-700 hover:bg-sage-50 flex items-center gap-2 transition-all duration-300 transform hover:scale-105 text-sm md:text-base py-2 h-auto"
            onClick={() => {
              window.open('mailto:PaytonMHunter7@gmail.com');
            }}
          >
            <Mail className="h-4 w-4" />
            <span>Email Me</span>
          </Button>
          
          <Button 
            variant="outline" 
            className="border-sage-600 text-sage-700 hover:bg-sage-50 flex items-center gap-2 transition-all duration-300 transform hover:scale-105 text-sm md:text-base py-2 h-auto"
            onClick={() => {
              window.open('https://calendly.com', '_blank', 'noopener,noreferrer');
              toast('Calendar opened', {
                description: 'Schedule a call at your convenience.',
              });
            }}
          >
            <Calendar className="h-4 w-4" />
            <span>Schedule a Call</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
